<template>
	<div>
		<topbar></topbar>


<div class="clear"></div>

<sortHeader v-model="sortParam"></sortHeader>
<!--顶部：导航 开始-->
<heardernav ref="navComp" :activeLi="activeLi" :isRefresh="isRefresh"></heardernav>
<!--顶部：导航 结束-->

<div class="clear mt15"></div>
<!--container 开始-->
<div class="w1200 bc">
	<!--位置 开始-->
    <div class="hq-crumb-wrap">
    	<ul>
        	<li class="item"><a href="#">Home</a></li>
            <li class="item sep">></li>
            <li class="item">{{sortParam}}{{catNameCn}}{{brandName}}</li>
        </ul>
    </div>
    <!--位置 结束-->
  <!-- 右侧商品 开始-->
  <div class="sp-side-wrap">
    	<div class="hd">
            <h3>Boutique Recommended</h3>
        </div>
        <ul>
            <li v-for="recommendGood in recommendGoodsList">
                <a class="fl pic" @click="toGoodsDetail(recommendGood.goodsCode,recommendGood.productType)"><img v-bind:src="recommendGood.imgMiddle" width="106" height="106"></a>
                <p class="title">
                    <a @click="toGoodsDetail(recommendGood.goodsCode,recommendGood.productType)">{{recommendGood.goodsNameEn}}</a>
                </p>
                <p class="price co2" v-if="recommendGood.productType!='sample'&&recommendGood.goodsPrice>0">{{recommendGood.goodsPrice}}point</p>
                <p class="price co2" v-if="recommendGood.productType!='sample'&&recommendGood.goodsPrice==0">{{recommendGood.unitPrice==0?"":"￥"+(recommendGood.unitPrice/100).toFixed(2)}}</p>
            </li>
        </ul>
    </div>
    <!-- 右侧商品 结束-->
    
    <!-- 商品搜索 开始-->
    <div class="sp-search-list">
  <div class="l-hd">
        	<div class="top-num fr">共{{totalItem}}条 <span class="co2">{{sortParam}}{{catNameCn}}</span></div>
        	<h3>search results</h3>
        </div>
  <div class="hq-selector">
            <div class="hd">
                <dl>
	            	<dt>Conditions：</dt>
	                <dd id="choosedCond">
	                	<span class="checked-item" v-bind:condType="condItem.condType" style="margin-top: 5px;" v-for="(condItem,index) in choosedCondItem">{{condItem.condName}}<a v-on:click="removeCondition(index,condItem.condType)" class="del"></a></span>
	                </dd>
	            </dl>
            </div>
            <div class="bd">
            		<dl v-if="firstCatList!=undefined&&firstCatList.length>0">
            			<dt>主类</dt>
	            		<dd>
	            			<div class="td_h">
	            				<!--<a v-for="(firstCat,index) in firstCatList" style="display: inline-block;" v-on:click="chooseFirstCat(firstCat.catCode)">{{firstCat.catNameCn}}</a>-->
	            				<a v-for="(firstCat,index) in firstCatList" style="display: inline-block;" v-on:click="chooseCondition($event,'firstCat',firstCat.catCode)">{{firstCat.catNameCn}}</a>
	            			</div>
	            		</dd>
	            	</dl>
            		<dl v-if="twoCategoryList!=undefined&&twoCategoryList.length>0">
            			<dt>分类</dt>
	            		<dd>
	            			<!--@click="getCatGoods(childCat.catCode,childCat.catNameCn)"-->
	            			<div class="td_h">
	            				<a v-for="(twoCategory,index) in twoCategoryList" style="display: inline-block;" v-on:click="chooseCondition($event,'catNameCn',twoCategory.catCode)">{{twoCategory.catNameCn}}</a>
	            			</div>
	            		</dd>
	            	</dl>
<!--
					<dl>
	            	<dt>品牌</dt>
	            		<dd>
	            			<!- @click="getCatGoods(childCat.catCode,childCat.catNameCn)"->
	            			<div class="td_brand_h">
	            				<a v-for="(brand,index) in brandList" style="display: inline-block;" v-on:click="chooseCondition($event,'brand',brand.id)">{{brand.brandNameCn}}</a>
	            			</div>
	            		</dd>
	            	</dl>
-->
		            <dl>
		            	<dt>Price：</dt>
		                <dd>
		                	<a v-on:click="chooseCondition($event,'amount','intervalAll')">Unlimited</a>
		                	<a v-on:click="chooseCondition($event,'amount','0,100')">0-100</a>
		                    <a v-on:click="chooseCondition($event,'amount','101,200')">101-200</a>
		                    <a v-on:click="chooseCondition($event,'amount','201,300')">201-300</a>
		                    <a v-on:click="chooseCondition($event,'amount','301,500')">301-500</a>
		                    <a v-on:click="chooseCondition($event,'amount','501,1000')">501-1000</a>
		                    <a v-on:click="chooseCondition($event,'amount','1001,5000')">1001-5000</a>
		                    <a v-on:click="chooseCondition($event,'amount','5000,')">5000 above</a>
		                </dd>
		            </dl>
                <dl>
                    <dt>Publish time: </dt>
					<dd>
					<a v-on:click="chooseCondition($event,'time','timeAll')">Unlimited</a>
					<a v-on:click="chooseCondition($event,'time','oneDay')">One day</a>
					<a v-on:click="chooseCondition($event,'time','twoDay')">Two days</a>
					<a v-on:click="chooseCondition($event,'time','oneWeek')"> Within a week</a>
					<a v-on:click="chooseCondition($event,'time','oneMonth')"> Within a month</a>
	                </dd>
                </dl>
            </div>
        </div>
        
  <div class="pro-tool mt20">
            <div class="fl">
                <ul>
                    <li v-bind:class='{"hover":sortCondition === "defaultSort"}' v-on:click="sortGoods('defaultSort')">Default</li>
					<li v-bind:class='{"hover":sortCondition === "saleAmount"}' v-on:click="sortGoods('saleAmount')">Sales <i v-bind:class='{" Up": sortSaleAmount=="asc"}'></i></li>
					<li v-bind:class='{"hover":sortCondition === "publishTime"}' v-on:click="sortGoods('publishTime')">Publish time <i v-bind:class='{ "up": sortPublishTime=="asc"}'></i></li>
					<li v-bind:class='{"hover":sortCondition === "price"}' v-on:click="sortGoods('price')">price <i v-bind:class='{" Up": sortPrice=="asc"}'></i></li>
					<li>
            			<div class="price-wrap">
							<div class="input-wrap">
								<input type="text" v-model="lower"/> - <input type="text" v-model="upper"/>
							</div>
							<div class="price-tool">
								<div class="price-tool-btn">
									<div class="fl"><a @click="clearUserDefined()">Clear</a></div>
									<div class="fr"><span @click="userDefinedCondition()">OK</span></div>
								</div>				
							</div>
						</div>
	                </li>
	            </ul>
            </div>
        </div>
       
        <div class="pro-list"  v-if="firstCatCode != 'spike'">
        	<ul>
            	<li v-for="goodsBo in goodsList">
                	<p class="img"><a @click="toGoodsDetail(goodsBo.goodsCode,goodsBo.productType)"><img v-bind:src="goodsBo.imgMiddle" width="265" height="265"></a></p>
                    <p class="title"><a @click="toGoodsDetail(goodsBo.goodsCode,goodsBo.productType)">{{goodsBo.goodsNameEn}}</a></p>
                    <div id="alert_btn" style="width: 20%;float: right;text-align: right;"><img v-if="goodsBo.seven_day_return=='Y'" src="../../../static/images/qitian.png" style="width: 17px;height: 17px;"/></div>
                    <p class="price" v-if="goodsBo.goodsPrice>0&&goodsBo.productType!='sample'"> {{goodsBo.goodsPrice}}积分</p>
                    <p class="price" v-if="goodsBo.goodsPrice==0&&goodsBo.productType!='sample'"> {{goodsBo.unitPrice==0?'':'￥'+(goodsBo.unitPrice/100).toFixed(2)}}</p>
                    <!--
                    <p class="shop"><i class="ico-shop-l"></i>
                    	<a @click="toGoodsDetail(goodsBo.goodsCode,goodsBo.productType)">{{goodsBo.shopName}}</a>
                    	<span class="cp1 f16" v-if="Math.floor(goodsBo.unitPrice/100*goodsBo.rewardPointRate/100)>0" 
												style="font-size: 0.6rem !important;border: 1px red solid;border-radius: 3px;padding: 0 0.2rem 0 0.2rem;color:red">赠{{Math.floor(goodsBo.unitPrice/100*goodsBo.rewardPointRate/100)}}积分</span>
                    	
                    </p>
                    -->
                </li>
            </ul>
        </div>
        <div class="bd"  v-if="firstCatCode == 'spike'">
        	<ul class="miaosha-ul">
            	<li v-for="goodsBo in goodsList">
                	<p class="pic tc"><a @click="toGoodsDetail(goodsBo.goodsCode,goodsBo.productType)"><img v-bind:src="goodsBo.imgMiddle" width="265" height="265"></a></p>
                    <p class="title"><a @click="toGoodsDetail(goodsBo.goodsCode,goodsBo.productType)">{{goodsBo.goodsNameEn}}</a></p>
                    <div class="line-price"><span class="co3">￥{{(goodsBo.unitPrice/100).toFixed(2)}}</span><span class="old">￥{{(goodsBo.marketPrice/100).toFixed(2)}}</span></div>
                	<div class="pinpainow_item_time">                                            
            				<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='end'">                         
                				over                      
                			</span> 
                			<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='wait_start'">                         
                				From the beginning <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>hours<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>minutes<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>seconds                        
                			</span> 
                			<span class="brandsknow_time_txt"  v-if="goodsBo.saleStatus==='on_sale'">                         
                				End of distance <i class="brandsknow_time_txt_time">{{goodsBo.hour}}</i>hours<i class="brandsknow_time_txt_time">{{goodsBo.minute}}</i>minutes<i class="brandsknow_time_txt_time">{{goodsBo.second}}</i>seconds                        
                			</span> 
                	</div>
                </li>
            </ul>
        </div>
        <div class="dp-pages tc">
            <a @click="prePage()"> < </a>
            <a v-bind:class='{"current_page":currentPage === page}' v-for="page in pageList" @click="queryByPage(page)">{{page}}</a>
            <a @click="nextPage()"> > </a>
        </div>
  </div>
    <!-- 商品搜索 结束-->
    <div class="clear"></div>
    <div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
</div>
<!--container 结束-->
<div class="clear"></div>
<footermenu></footermenu>
<footercopyright></footercopyright>
	</div>
</template>

<script>
	//import {jQuery} from "../../../static/js/jquery.min.js"
	import jQuery from 'jquery';
	import TopBar from '@/components/TopBar'
	import API from "../../../static/api/api.js"
	import {getImgUrl,dateFormat,getValueFromMap,showMoney,parseResult,getIndexUrl,getAboutUsUrl,getEmallUrl,getUcUrl,sysContactUrl} from "../../../static/js/emallUtils.js"
	import dbmain from '../../../static/js/db-main.js'
	import Header from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import FooterCopyright from '@/components/FooterCopyright'
	import HearderNav from '@/components/HearderNav'
	export default {
		name: 'goodsList',
		components: {
			'topbar':TopBar,
			'sortHeader':Header,
			'footermenu':FooterMenu,
			'footercopyright':FooterCopyright,
			'heardernav':HearderNav
		},
		data(){
            return {
            	isRefresh:true,
            	goodsList:[],
            	recommendGoodsList:[],
            	sortCondition:'defaultSort',
			    sortSaleAmount:'',
			    sortPublishTime:'',
			    sortPrice:'',
			    choosedCondItem:[],
		     	catCode:'categoryAll',
		     	interval:'intervalAll',
		     	sortTime:'timeAll',
		     	currentPage:1,
		     	totalPage:1,
		     	orderBy:'',
		     	orderAsc:'',
		     	shopCode:'',
		     	pageList:[1],
		     	totalItem:0,
		     	sortParam:'',
		     	shoppingCartNum:0,
				boList:[],
				count:0,
				goodsImgs:[],
				sumMoney:0,
				goodsName:'',
				goodsNameEn:'',
				firstCatCode:'',
				shopCode:'',
				mobile:'',
				isLogin:false,
			    isShow:false,
			    account:'',
			     userCenterUrl:'',
				loginUrl:'',
				registerUrl:'',
				logoutUrl:'',
				aboutUsUrl:'',
				indexUrl:'',
				orderUrl:'',
				catNameCn:'',
				brandId:0,
				brandName:'',
				allCount:0,
				payCount:0,
				putCount:0,
				receiveCount:0,
				sendCount:0,
				closeCount:0,
	   			computeFlag:'',
				contactUrl:'',
				showItem:7,
				isInit:false,
				lower:'',
				upper:'',
				productType:'meterial',//产品类型
				orderType:'',//订单类型
				activeLi:'meterial',
				twoCategoryList:[],
				brandList:[],
				firstCatList:[],
				catMap:[]
				
            }
        },
        watch:{
        	sortParam:function(newValue, oldValue){
//      		alert(this.sortParam);
//				alert(newValue+" to "+oldValue);
				if(oldValue!=undefined&&oldValue!=''){
					this.getRecommendGoods();
					this.getGoods();
				}
        	}
        	
        },
        methods:{
        	orderShow:function(){
				jQuery(".orders-list").show();
			},
			orderHide:function(){
				jQuery(".orders-list").hide();
			},
			shopCarShow:function(){
				jQuery(".goods-list").show();
			},
			shopCarHide:function(){
				jQuery(".goods-list").hide();
			},
        	getOrderCount:function(shopCode){
        		var that=this;
        		API.getOrderCount(function(ret){
        			if(ret.code == "success"){
        				that.allCount = ret.data.allCount;
        				that.payCount = ret.data.payCount;
        				that.putCount = ret.data.putCount;
        				that.receiveCount = ret.data.receiveCount;
        				that.sendCount = ret.data.sendCount;
        				that.closeCount = ret.data.closeCount;
        			}
        		})
        	},
        	logout:function(){
				localStorage.clear();
				API.loginOut(function(ret){});
				window.location.href = this.logoutUrl;
			},
			clearCookie:function(){
				var keys=document.cookie.match(/[^ =;]+(?=\=)/g); 
				if (keys) { 
				for(var i = keys.length; i--;) 
					document.cookie=keys[i]+'=0;expires=' + new Date( 0).toUTCString() 
				} 
			},
        	goOrder:function(tradeStatus){
				var account = localStorage.getItem("account");
				if(account != undefined && account != ""){
					window.location.href=this.orderUrl+"?tradeStatus="+tradeStatus;
				}else{
					window.location.href=getUcUrl()+'/login.htm';
				}
			},
        	 mobileAppShow:function(){
		  		this.isShow = true;
		  	 },
		  	 mobileAppHidden:function(){
		  		this.isShow = false;
		  	 },
        	jumpTo:function(name){
		  		this.$router.push({ name:name});
		  	},
        	toGoodsDetail:function(goodsCode,productType){
				//this.$router.push({ name: 'goodsdetail', query:{goodsCode:goodsCode}});
				/*if(productType!=undefined&&productType=='sample'){//样品
					let routeData = this.$router.resolve({ path: '/sampleDetail', query: {goodsCode: goodsCode } });
					window.open(routeData.href, '_blank');
				}else{*/
					let routeData = this.$router.resolve({ path: '/goodsDetails', query: {goodsCode: goodsCode,orderType: this.orderType,productType: this.productType } });
					window.open(routeData.href, '_blank');
				/*}*/
		  	},
		  	prePage:function(){
		  		if(this.currentPage > 1){
		  			 this.currentPage = this.currentPage -1;
		  			 this.adjustPageArray(this.currentPage);
		  			 this.getGoods();
		  		}
		  	},
		  	nextPage:function(){
		  		if(this.currentPage < this.totalPage){
		  			this.currentPage = this.currentPage +1;
		  			this.adjustPageArray(this.currentPage);
		  			this.getGoods();
		  		}
		  	},
		  	queryByPage:function(page){
	  			this.currentPage = page;
	  			this.adjustPageArray(this.currentPage);
	  			this.getGoods();
		  	},
		  	adjustPageArray:function(page){
		  		if(page == this.pageList[6] && (page+2) <= this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.push(page+2);
		  			this.pageList.shift();
		  			this.pageList.shift();
		  		}else if(page == this.pageList[6] && (page+1) == this.totalPage){
		  			this.pageList.push(page+1);
		  			this.pageList.shift();
		  		}else if(page == this.pageList[0] && page >= 3){
		  			this.pageList.unshift(page-1);
		  			this.pageList.unshift(page-2);
		  			this.pageList.pop();
		  			this.pageList.pop();
		  		}else if(page == this.pageList[0] && page == 2){
		  			this.pageList.unshift(page-1);
		  			this.pageList.pop();
		  		}
		  	},
		  	initPageArray:function(){
			 	var pageList = new Array();
			 	var totalPage = this.totalPage;
	         	for(var i=1;i<=totalPage;i++){
	     	 		if(i <= this.showItem){
	     	 			pageList.push(i);
	     	 		}
	         	}
				this.pageList = pageList;
			},
			clearUserDefined:function(){
				this.lower = '';
				this.upper = '';
			},
			userDefinedCondition:function(){
				this.lower = this.lower.trim();
				this.upper = this.upper.trim();
				var sortParams = '';
				if(this.lower != ''&&this.upper != ''){
					sortParams = this.lower + ',' + this.upper;
				}else if(this.lower == ''&& this.upper != ''){
					sortParams =  '0,' + this.upper;
				}else if(this.lower != ''&& this.upper == ''){
					sortParams = this.lower + ',';
				}
				this.chooseCondition('','amount',sortParams);
			},
			//选择一级类目时
			chooseFirstCat:function(firstCatCode){
				this.firstCatCode=firstCatCode;
				if(this.catMap!=undefined&&this.catMap[firstCatCode]!=undefined&&this.catMap[firstCatCode]!=null){
					this.twoCategoryList=JSON.parse(this.catMap[firstCatCode]);
				}
			},
		  	chooseCondition:function(event,type,sortParams){
		  		if(event != ''){
		  			var condText = event.target.innerText;
				    if(condText != "不限"){
		  				var condText = event.target.innerText;
					    if(jQuery("#choosedCond").find("span[condType='"+type+"']").length != 0){
		  					jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
					    }
					    this.choosedCondItem.push({condName:condText,condType:type});
			  		}else{
			  			jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
			  		}
			  		
			  		if(type == 'amount'){
		  				this.clearUserDefined();
			  		}
		  		}else{
		  			if(type == 'amount'){
		  				if(jQuery("#choosedCond").find("span[condType='"+type+"']").length != 0){
		  					jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
					    }
			  		}
		  		}
		  		
		  		if(type == 'amount'){
	  				this.interval = sortParams;
		  		}else if(type == 'cat'){
		  			  this.catCode = sortParams;
		  		}else if(type == 'time'){
		  			  this.sortTime = sortParams;
		  		}else if(type == 'catNameCn'){
		  			this.catCode = sortParams;
		  		}else if(type == 'brand'){
		  			this.brandId = sortParams;
		  		}else if(type == 'firstCat'){//选择了一级类目
		  			if(this.firstCatCode!=sortParams){
		  				this.firstCatCode=sortParams;
		  				this.catCode = "categoryAll";//换一级类目后二级类目初始化为全部
		  				if(this.catMap[sortParams]!=undefined&&this.catMap[sortParams]!=null){
		  					this.twoCategoryList=JSON.parse(this.catMap[sortParams]);
		  				}else{
		  					this.twoCategoryList=[];
		  				}
						
						if(jQuery("#choosedCond").find("span[condType='catNameCn']").length != 0){
		  					jQuery("#choosedCond").find("span[condType='catNameCn']").remove();
					    }
		  			}
		  		}
		  		this.currentPage=1;//页码初始化为1
		  		this.getRecommendGoods();
				this.getGoods();
		  	},
		  	removeCondition:function(index,type){
		  			if(type == 'amount'){
		  				this.interval = "intervalAll";
			  		}else if(type == 'cat'){
			  			  this.catCode = "categoryAll";
			  		}else if(type == 'time'){
			  			  this.sortTime = "timeAll";
			  		}else if(type == 'catNameCn'){
			  			this.catCode = "categoryAll";
			  		}else if(type == 'brand'){
			  			this.brandId = 0;
			  		}else if(type == 'firstCat'){
			  			this.firstCatCode='';
			  		}
//		  			this.choosedCondItem.splice(index,1);
		  			jQuery("#choosedCond").find("span[condType='"+type+"']").remove();
		  			this.getRecommendGoods();
					this.getGoods();
		  	},
		  	findGoods:function(){
		  			this.resetCond();
		  			this.getRecommendGoods();
					this.getGoods();
		  	},
		  	findShops:function(){
		  			this.$router.push({ name: 'shopsList', query:{sortParam:this.sortParam}});
		  	},
		  	sortGoods:function(sortCondition){
		  		 this.currentPage = 1;
		  		 this.sortCondition = sortCondition;
		  		 if(sortCondition == "saleAmount"){
		  		 			this.orderBy = "sale_number";
		  		 		  if(this.sortSaleAmount == ''){
		    					this.sortSaleAmount = "desc";
			    			}else if(this.sortSaleAmount == 'desc'){
			    				this.sortSaleAmount = "asc";
			    			}else if(this.sortSaleAmount == 'asc'){
			    				this.sortSaleAmount = "desc";
			    			}
			    			this.orderAsc = this.sortSaleAmount;
		  		 }
		  		 if(sortCondition == "publishTime"){
		  		 			this.orderBy = "gmt_create";
		  		 		  if(this.sortPublishTime == ''){
		    					this.sortPublishTime = "desc";
			    			}else if(this.sortPublishTime == 'desc'){
			    				this.sortPublishTime = "asc";
			    			}else if(this.sortPublishTime == 'asc'){
			    				this.sortPublishTime = "desc";
			    			}
			    			this.orderAsc = this.sortPublishTime;
		  		 }
		  		 if(sortCondition == "price"){
		  		 			this.orderBy = "unit_price";
		  		 		  if(this.sortPrice == ''){
		    					this.sortPrice = "desc";
			    			}else if(this.sortPrice == 'desc'){
			    				this.sortPrice = "asc";
			    			}else if(this.sortPrice == 'asc'){
			    				this.sortPrice = "desc";
			    			}
			    			this.orderAsc = this.sortPrice;
		  		 }
		  		 if(sortCondition == "defaultSort"){
		  		 		 this.orderBy = "";
		  		 		 this.orderAsc = "";
		  		 }
		  		 this.getGoods();
				 this.getRecommendGoods();
		  	},
		    getRecommendGoods:function(){
				var that = this;
				var interval = that.interval;
				var catCode = that.catCode;
				var cabinetId = "";
				var pageSize = 5;
				var isQueryAll = "n";
				var currentPage = 1;
				var orderBy = "sale_number";
				var orderAsc = "desc";
			    var shopCode = that.shopCode;
			    var sortTime = "";
			    var goodsName = "";//encodeURI(that.sortParam);
			    var goodsNameEn = encodeURI(that.sortParam);
			    var firstCatCode = that.firstCatCode;
			    var brandId = that.brandId;
			    var productType=that.productType;
			    var orderType=that.orderType;
			    
				API.getGoodsList(cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,goodsNameEn,firstCatCode,brandId,productType,orderType,function(ret){
					if(ret.code == "success"){
						var goods = ret.data.goods;
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
							}
						}
						that.recommendGoodsList = goods;
					}
				});
			 },
			 getGoods:function(){
				var that = this;
				var interval = that.interval;
				var catCode = that.catCode;
				var isQueryAll = "n";
			    var shopCode = that.shopCode;
				var cabinetId = "";
				var pageSize = 9;
				var currentPage = that.currentPage;
				var orderBy = that.orderBy;
				var orderAsc = that.orderAsc;
		   		var sortTime = that.sortTime;
		   		var goodsName = "";//encodeURI(that.sortParam);
		   		var goodsNameEn = encodeURI(that.sortParam);
		   		var firstCatCode = that.firstCatCode;
		   		var brandId = that.brandId;
		   		var productType=that.productType;
		   		var orderType=that.orderType;
				API.getGoodsList(cabinetId,catCode,interval,currentPage,orderBy,orderAsc,shopCode,sortTime,pageSize,isQueryAll,goodsName,goodsNameEn,firstCatCode,brandId,productType,orderType,function(ret){
					if(ret.code == "success"){
						var goods = ret.data.goods;
						that.totalItem = ret.data.totalItem;
						var totalPage = ret.data.totalPage;
						if(totalPage != undefined && totalPage != 0 && totalPage != that.totalPage ){
							that.totalPage = ret.data.totalPage;
							that.initPageArray();
						}else if(totalPage != undefined && totalPage == 0){
							that.totalPage = 1;
							that.initPageArray();
						}
						if(goods != undefined){
							for(var i=0;i<goods.length;i++){
								//商品图片
								var imgMiddle = goods[i].imgMiddle;
			                    if(imgMiddle.indexOf(";")!=-1){
			                    	imgMiddle=imgMiddle.split(";")[0];
			                    }
			                    imgMiddle = getImgUrl()+"/upload/show.htm?filePath="+imgMiddle;
			                    goods[i].imgMiddle = imgMiddle;
			                    
			                    if(firstCatCode=='spike'){
			                    	
	 						var marketPrice=JSON.parse(goods[i].attrValue).marketPrice;
	 						var saleTimeStr=JSON.parse(goods[i].attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(goods[i].attrValue).saleEndTimeShow;
	 						if(marketPrice!=undefined && marketPrice!=""){
	                    		goods[i].marketPrice=marketPrice;
			 				}else{
			 					goods[i].marketPrice=goods[i].unitPrice;
			 				}
			 				if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);
								
								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);
								
								//如果当期日期大于销售结束日期 xxx
								if(new Date() > saleEndDate){
									goods[i].saleStatus="end";
								}else if(new Date() < saleDate){//如果当期时间小于上架时间，展示距离开始 时间
									goods[i].saleStatus="wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000); 
// 									goods[i].day=days;
   									goods[i].hour=hours;
   									goods[i].minute=minutes;
   									goods[i].second=seconds;
								}else{
									goods[i].saleStatus="on_sale";
									
									var begSeconds = saleEndDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000);  
// 									goods[i].day=days;
   									goods[i].hour=hours;
   									goods[i].minute=minutes;
   									goods[i].second=seconds;
								}
			 				}

			                    }
							}
						}
						that.goodsList = goods;
						if(!that.isInit){
							that.isInit = true;
							that.initPageArray();
						}
					}
				});
			 },
			getShoppingCartNum:function(shopCode){
        		var that=this;
        		API.getShoppingCartNum(function(ret){
        			if(ret.code == "success"){
        				that.shoppingCartNum = ret.data.shoppingCartNum;
        			}
        		});
        	},
        	getShoppingCartList:function(){
        		var that=this;
        		API.getShoppingCartList(function(ret){
					 if(ret.code == "success"){
					 	that.boList = ret.data.boList;
					 	var totalCount = 0;
					 	var bos = new Array();
					 	bos = ret.data.boList;
					 	var money = 0;
					 	for(var i =0; i<bos.length;i++){
					 		var imgSmall = bos[i].imgSmall;
		                    if(imgSmall.indexOf(";")!=-1){
		                    	imgSmall=imgSmall.split(";")[0];
		                    }					 		
					 		bos[i].imgSmall = getImgUrl()+"/upload/show.htm?filePath="+imgSmall;
					 		money = money + bos[i].goodsPrice * bos[i].goodsNumber;
					 		totalCount = totalCount + bos[i].goodsNumber;
					 	}
					 	that.sumMoney = money;
					 	that.count = totalCount;
					 	
					 }
        		})
        	},
        	deleteGoods:function(goodsCode){
        		var that=this;
        		API.deleteGoods(goodsCode, function(ret){
        			if(parseResult(ret, null, false)) {
						jQuery("#" + goodsCode + "_cart_pro").remove();
						
					}
        		})
        	},
        	goIndex:function(){
		  		this.$router.push({name:'index'});
		  	},
        	getMoreCatGoods:function(catCode,catNameCn){
        		this.catNameCn = catNameCn;
        		this.resetCond();
        		this.sortParam = "";
        		this.firstCatCode = catCode;
        		this.sortParam = "";
		  	 	this.getRecommendGoods();
				this.getGoods();
		  	},
		  	getCatGoods:function(catCode,catNameCn){
		  		this.catNameCn = catNameCn;
		  	 	this.resetCond();
        		this.sortParam = "";
        		this.catCode = catCode;
        		this.firstCatCode = "";
        		this.sortParam = "";
		  	 	this.getRecommendGoods();
				this.getGoods();
		  	},
        	resetCond:function(){
        		this.interval = "intervalAll";
        		this.catCode = "categoryAll";
        		this.sortTime = "timeAll";
        		this.firstCatCode = "";
        		this.orderBy = "";
        		this.orderAsc = "";
        		jQuery("#choosedCond").html("");
        	},
        	computeTime:function(){
				var that=this;
				var goodsList=that.goodsList;
	 					for(var j=0;j<goodsList.length;j++){
	 						var saleTimeStr=JSON.parse(goodsList[j].attrValue).saleTimeShow;
	 						var saleEndTimeStr=JSON.parse(goodsList[j].attrValue).saleEndTimeShow;
	 						
			 				if(saleEndTimeStr!=undefined&&saleEndTimeStr!=''){
			 					saleEndTimeStr=saleEndTimeStr.replace(/-/g,"/");
								var saleEndDate = new Date(saleEndTimeStr);
								
								saleTimeStr=saleTimeStr.replace(/-/g,"/");
								var saleDate = new Date(saleTimeStr);
								
								//如果当期日期大于销售结束日期 xxx
								if(new Date() > saleEndDate){
									goodsList[j].saleStatus="end";
								}else if(new Date() < saleDate){//如果当期时间小于上架时间，展示距离开始 时间
									goodsList[j].saleStatus="wait_start";
									var begSeconds = saleDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000);  
   									goodsList[j].hour=hours;
   									goodsList[j].minute=minutes;
   									goodsList[j].second=seconds;
								}else{
									goodsList[j].saleStatus="on_sale";
									
									var begSeconds = saleEndDate.getTime() - new Date().getTime();   //时间差的毫秒数        
    								//计算出相差天数  
//  								var days=Math.floor(begSeconds/(24*3600*1000));  
    								//计算出小时数  
    								var leave1=begSeconds%(24*3600*1000);    //计算天数后剩余的毫秒数  
    								var hours=Math.floor(begSeconds/(3600*1000));  
    								//计算相差分钟数  
    								var leave2=leave1%(3600*1000);        //计算小时数后剩余的毫秒数  
    								var minutes=Math.floor(leave2/(60*1000));  
    								//计算相差秒数  
    								var leave3=leave2%(60*1000);      //计算分钟数后剩余的毫秒数  
   									var seconds=Math.round(leave3/1000);  
   									goodsList[j].hour=hours;
   									goodsList[j].minute=minutes;
   									goodsList[j].second=seconds;
								}
			 				}
	 					}
	 				that.goodsList = goodsList;
					if(!that.isInit){
						that.isInit = true;
						that.initPageArray();
					}
				},
				getCategoryListByCode:function(parentCode){
	        		var that=this;
	        		API.getCategoryListByCode(parentCode, function(ret){
	        			if(ret.data.catList!=null||ret.data.catList!=""){
	        				that.twoCategoryList=ret.data.catList;
	        			}
	        		})
	        	},
	        	getAllCategoryMap:function(){
	        		var that=this;
	        		var productType='';
	        		if(that.productType!=undefined){
	        			if(that.productType=='sample'){
	        				productType='product';//样品和现货公用一套类目，按product来查询
	        			}else{
	        				productType=that.productType;
	        			}
	        		}
	        		API.getAllCategoryMap(productType,function(ret){
	        			if(ret.data.firstCatList!=null||ret.data.firstCatList!=""){
	        				that.firstCatList=ret.data.firstCatList;
	        			}
	        			if(ret.data.catMap!=null||ret.data.catMap!=""){
	        				that.catMap=ret.data.catMap;
	        			}
	        		})
	        	},
	        	getBrandList:function(){
	        		var that=this;
	        		API.getBrandList(function(ret){
	        			if(ret.data.brandBoList!=null||ret.data.brandBoList!=""){
	        				that.brandList=ret.data.brandBoList;
	        			}
	        		})
	        	},
	        	showMoreCategory:function(){
	        		jQuery('.td_div').toggleClass('td_h');
	        	},
	        	showMoreBrand:function(){
	        		jQuery('.td_brand_div').toggleClass('td_brand_h');
	        	}
  			},
        ready:function(){
        	
		},
		beforeDestroy () {
			var that=this;
			if(that.firstCatCode == 'spike'){
     			window.clearInterval(this.computeFlag);
     		}
  		},
		mounted(){
			window.scrollTo(0, 0);
//			this.$refs.navComp.getCat();//不用获取首页的类目
			var account = localStorage.getItem("account");
			if(account != undefined && account != ""){
				this.isLogin = true;
				this.account = account;
			}
			this.userCenterUrl = getUcUrl() + '/index/default.htm';
			this.loginUrl = getUcUrl() + '/login.htm';
//			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm';
			this.registerUrl = getUcUrl() + '/custm/user/user_reg_add.htm?formCode=MCHT_USER_FORM';
			this.logoutUrl = getUcUrl() + '/logout.htm';
			this.aboutUsUrl = getAboutUsUrl();
			this.indexUrl = getIndexUrl();
			this.orderUrl = getEmallUrl() + '/orderManage/myOrderList.htm';
			var sortParam = this.$route.query.sortParam;
			var firstCatCode = this.$route.query.firstCatCode;
			var shopCode = this.$route.query.shopCode;
			var catCode = this.$route.query.catCode;
			var catNameCn = this.$route.query.catNameCn;
			var brandId = this.$route.query.brandId;
			var brandName = this.$route.query.brandName;
			//产品类型
			if(this.$route.query.productType!=undefined&&this.$route.query.productType!=""){
				this.productType=this.$route.query.productType;
			}
			if(this.$route.params.productType!=undefined&&this.$route.params.productType!=""){
				this.productType=this.$route.params.productType;
			}
			if(this.productType=='sample'||this.productType=='meterial'){
				this.activeLi=this.$route.query.productType;
			}
			//下单类型
			if(this.$route.query.orderType!=undefined&&this.$route.query.orderType!=""){
				this.orderType=this.$route.query.orderType;
			}
			if(this.$route.params.orderType!=undefined&&this.$route.params.orderType!=""){
				this.orderType=this.$route.params.orderType;
			}
			if(sortParam != undefined){
				this.sortParam = sortParam;
			}
			if(firstCatCode != undefined){
				this.firstCatCode = firstCatCode;
			}
			if(shopCode != undefined){
				this.shopCode = shopCode;
			}
			var that=this;
			if(firstCatCode!=undefined && firstCatCode == 'spike'){
     			this.computeFlag = window.setInterval(function(){
	 				that.computeTime();//计算倒计时
	 			},1000);
     		}
			if(catCode != undefined){
				this.catCode = catCode;
				this.getCatGoods(this.catCode);
			}else{
				this.getRecommendGoods();
				this.getGoods();
			}
			if(catNameCn != undefined){
				this.catNameCn = decodeURI(catNameCn);;
			}
			if(brandId != undefined){
				this.brandId = brandId;;
			}
			if(brandName != undefined){
				this.brandName = brandName;;
			}
			//this.getRecommendGoods();
			//this.getGoods();
			this.getShoppingCartNum();
			this.getShoppingCartList();
			this.getOrderCount();
			this.contactUrl = sysContactUrl;
			if(firstCatCode!=undefined&&firstCatCode!=""){
				this.getCategoryListByCode(firstCatCode);
			}else{
				this.getAllCategoryMap();
			}
			//获取品牌信息
			this.getBrandList();
		}
	}
</script>

<style scoped>
	.current_page{
		border: solid 1px #ff6600;
	}
	.demensional_code{
		height: 100px;
	    width: 100px;
	    z-index: 99;
	    background-color: gainsboro;
	    position: absolute;
	    right: 45px;
	}
	.price-wrap{
		position: absolute;
	}
	.price-tool{
		display: none;
		background: #fff;
		margin-top: -37px;
		margin-left: -10px;
		padding-top:40px;
		width:calc(100% + 20px);
		border:1px solid #999;
		box-shadow:0 0 10px rgba(0,0,0,.5);	
		color:#ddd;		
		overflow:hidden;	
	}
	.price-tool-btn{
		overflow: hidden;
		padding:10px;
	}
	.price-tool-btn a{
		display:block;
		color:#0069B7;
		padding:3px 8px;
	}
	.price-tool-btn span{
		display:block;
		background: #f7f7f7;
		border:1px solid #dcdcdc;
		color: #333;
		padding:3px 8px;
		cursor:pointer;
	}
	.input-wrap input{
		width: 80px;
		border:1px solid #dcdcdc;
		height:25px;
		border-radius:0;
		outline: none;
		text-indent:10px;
	}
	.price-wrap:hover .price-tool{
		display: block;
	}
	.td_div {
    float: left;
    width: 82%;
    height: 22px;
    overflow: hidden;
	}
	.td_h{
    height: auto;
    overflow: auto;
	}
	.td_brand_div {
    float: left;
    width: 82%;
    height: 22px;
    overflow: hidden;
	}
	.td_brand_h{
    height: auto;
    overflow: auto;
	}
</style>


// WEBPACK FOOTER //
// src/page/goods/meterialList.vue